export default "__VITE_ASSET__COL2Zqx$__"